import { render, staticRenderFns } from "./list_item.vue?vue&type=template&id=1c5c49e0"
import script from "./list_item.vue?vue&type=script&lang=js"
export * from "./list_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports